import { render } from "./choosePeople.vue?vue&type=template&id=57c2c91a&scoped=true"
import script from "./choosePeople.vue?vue&type=script&lang=js"
export * from "./choosePeople.vue?vue&type=script&lang=js"

import "./choosePeople.vue?vue&type=style&index=0&id=57c2c91a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c2c91a"]])

export default __exports__